import apis from "../../core/apis.js";

class PaymentCycleResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.paymentCycle).get(options);
  }

  get(id) {
    return this.$resource(apis.paymentCycle + id).get();
  }

  search(search = "") {
    return this.$resource(apis.paymentCycle).get({ search });
  }

  latest() {
    return this.$resource(apis.paymentCycle + "latest").get();
  }

  post(item) {
    return this.$resource(apis.paymentCycle).save(item);
  }

  update(id, item) {
    return this.$resource(apis.paymentCycle + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default PaymentCycleResource;



// WEBPACK FOOTER //
// ./src/resources/paymentCycle/paymentCycle.resource.js